module.exports = __webpack_public_path__ + "static/header-e61ad81a956e42d7852b830679cf600a.png";